export default "__VITE_ASSET__D86ViEVF__"